import { render } from "./bp11dsbDirection.vue?vue&type=template&id=4fb206c4&scoped=true"
import script from "./bp11dsbDirection.vue?vue&type=script&lang=js"
export * from "./bp11dsbDirection.vue?vue&type=script&lang=js"

import "./bp11dsbDirection.vue?vue&type=style&index=0&id=4fb206c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb206c4"]])

export default __exports__